import React from "react";
import styles from "./index.module.scss";
import { FeatureItem } from "./util";
/**
 * 单个店铺介绍
 */
export default function SingleMall(props: { data: FeatureItem }) {
  const { data } = props;
  return (
    <>
      <section className={styles.imgWrapper}>
        <img src={data.src} alt="introduce" className={styles.mallSrc} />
      </section>
      <section className={styles.mallIntroduce}>
        <h2 className={styles.mallTitle}>{data.title}</h2>
        <div className={styles.mallDescription}>{data.description}</div>
      </section>
    </>
  );
}
